import { render, staticRenderFns } from "./modalAddSocialLevel.vue?vue&type=template&id=5256e37c&"
import script from "./modalAddSocialLevel.vue?vue&type=script&lang=js&"
export * from "./modalAddSocialLevel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports